import { IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SlideFactory } from "../Slider/SecondScreenHelp";
import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";

//namespace SlotGames2
//{
	export class PandaQuest2_2Screen extends SlotGameType1_2_2Screen
	{
   
		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/go3v2.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
		//	protected freegameBonusFactory: FreegameBonusFactory2 = new PandaQuestFreegame2BonusFactory();
		//protected slideFactory: SlideFactory = new PandaQuestSecondScreenHelpFactory();

		//protected freegameBonusFactory_2screen: FreegameBonusFactory2_2screen = new PandaQuestFreegame2BonusFactory_2Screen();

		protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
	{
		

	}
	
	


	
}
// }